import { useConfig } from '@kss/theme';
import { Logo } from './Logo';
import { ThemeControls } from './ThemeControls';

export function WebFooter() {
  const { brand } = useConfig();
  return (
    <footer className='mt-10 border-t border-border bg-surface-card px-6 py-8'>
      <div className='mx-auto flex max-w-[1160px] flex-col items-center justify-between gap-4 sm:flex-row'>
        <Logo size='sm' />
        {/* The outlet's own name, not the product's — this read "© … ThaliOS" while the
            Logo two lines up already used config.brand correctly. */}
        <p className='text-xs text-content-muted'>
          © {new Date().getFullYear()} {brand?.trim() || 'Restaurant ordering & operations'}
        </p>
        <div className='flex gap-5 text-xs font-semibold text-content-secondary'>
          <a href='#'>About</a>
          <a href='#'>Help</a>
          <a href='#'>Terms</a>
        </div>
      </div>
      {/* Theme colour + light/dark + language — moved here from the top bar. */}
      <div className='mx-auto mt-6 flex max-w-[1160px] flex-col items-center justify-between gap-3 border-t border-border pt-6 sm:flex-row'>
        <span className='text-[11px] font-semibold uppercase tracking-wide text-content-muted'>Appearance &amp; language</span>
        <ThemeControls />
      </div>
    </footer>
  );
}
